import { ChakraProvider } from "@chakra-ui/react"
import { isVsmeMethod } from "@esgt/types"
import { RatingAccount } from "lib/providers"
import { RatingProvider, useRating } from "lib/providers/RatingProvider"
import { theme } from "lib/theme"
import { useParams } from "react-router-dom"
import styled from "styled-components"
import { VSMEReport } from "../VSMEReport/VSMEReport"
import { CompanyInfoAndTexts } from "./CompanyInfoAndTexts"
import { CustomRatingComment } from "./CustomRatingComment"
import { EndNotes } from "./EndNotes"
import { FreeOutro } from "./FreeOutro"
import { Frontpage } from "./Frontpage"
import { Indicators } from "./Indicators"
import { FreeIntro, Intro } from "./Intro"
import { KPIs } from "./KPIs"
import { SunburstChart } from "./SunburstChart"
import { TOC } from "./TOC"
import { Page } from "./components"
import { usePagedJS } from "./usePagedJS"

const Container = styled.div`
	font-family: Roboto, system-ui, -apple-system, sans-serif !important;
	font-weight: 400;
	-webkit-print-color-adjust: exact;
`

const LoadingRating = () => {
  const { isReady, isFree, method } = useRating()

  usePagedJS(isReady && !!method)

  if (!isReady) {
    return null
  }

  if (isVsmeMethod(method?.name)) {
    return (
      <Container>
        <VSMEReport />
      </Container>
    )
  }

  return (
    <Container>
      <Frontpage />
      <TOC />
      {isFree ? <FreeIntro /> : <Intro />}
      <CompanyInfoAndTexts />
      <SunburstChart />
      {!isFree && <CustomRatingComment />}
      {!isFree && <Indicators />}
      <KPIs />
      <Page named="legacy" lastPage={!isFree}>
        <EndNotes />
      </Page>
      {isFree && <FreeOutro />}
    </Container>
  )
}

export const Report: React.FC = () => {
  const { id } = useParams()

  if (!id) return <h1>No ID found: {id}!</h1>

  const ratingId = id.replace(/-/g, ".")

  return (
    <ChakraProvider theme={theme}>
      <RatingAccount.Provider ratingId={ratingId}>
        <RatingProvider ratingId={ratingId}>
          <LoadingRating />
        </RatingProvider>
      </RatingAccount.Provider>
    </ChakraProvider>
  )
}
